import React from 'react';
import PropTypes from 'prop-types';
import { get, filter } from 'lodash';
import { connect } from 'react-redux';
import { deleteCalendarPricing, fetchCalendarPricing } from '../../app-main/actions/calendarPricing';
import { toggleModal } from '../../app-main/actions/modal';

const DeletePricingModalHoc = (WrappedComponent) => {
  class HOC extends React.Component {
    constructor (props) {
      super(props);

      this.deletePricing = this.deletePricing.bind(this);
      this.onClose = this.onClose.bind(this);
    }

    onClose () {
      this.props.dispatch(toggleModal(''));
    }

    deletePricing () {
      const priceId = get(this.props, 'modal.modalData.priceId', '');
      const listingId = get(this.props, 'listing.data._id', '');
      this.props.dispatch(deleteCalendarPricing(priceId, this.props.token))
        .then((pricingResponse) => {
          const groupId = get(pricingResponse, 'group_id', '');
          const pricingData = filter(get(this.props, 'calendarPrice.data.prices_by_group', []), { group_id: groupId })[0];
          const value = get(this.props, 'listing.data.prices.0.value', 0);

          analyticsIntegrations.calendarPricingAction('price_by_day_removed',
            Object.assign({}, pricingData, { listing_id: listingId, value }));

          this.props.dispatch(fetchCalendarPricing(listingId));
          return this.onClose();
        });
    }

    render () {
      const { calendarPrice = {} } = this.props;
      return (
        <WrappedComponent
          deletePricing={this.deletePricing}
          isLoading={calendarPrice.isPatching}
          error={calendarPrice.deleteError}
          onClose={this.onClose}
          {...this.props}
        />
      );
    }
  }

  HOC.propTypes = {
    listingId: PropTypes.string,
    dispatch: PropTypes.func.isRequired,
    calendarPrice: PropTypes.object.isRequired,
    token: PropTypes.string
  };

  const mapStateToProps = (state) => {
    const modal = get(state, 'modal');
    const banner = get(state, 'banner');
    const token = get(state, 'auth.accessToken', '');
    const calendarPrice = get(state, 'calendarPrice', {});
    const listing = get(state, 'listing', {});

    return {
      modal,
      banner,
      token,
      calendarPrice,
      listing
    };
  };
  return connect(mapStateToProps)(HOC);
};


export default DeletePricingModalHoc;
